export enum LandlordUserTypes {
  COMPANYADMIN = 'COMPANYADMIN',
  EMPLOYEE = 'EMPLOYEE',
  PROPERTYMANAGER = 'PROPERTYMANAGER'
}
